import { DataSource, Label, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutOrderPayablesProfileList extends Layout {
    labelPageTitle: Label;
    sourceOrderPayablesProfile: DataSource;
    tableOrderPayableProfiles: Table;
}
